<template>
    <b-card>
        <b-card-header>Område</b-card-header>
        <b-card-body>
            <b-col>Namn:<b-input v-model="name" placeholder="Ange namn på området"></b-input> </b-col>

            <b-button variant="outline-secondary" block v-for="(l,i) in list" :key="i" 
                @click="name=l">{{ l }}
                <b-button variant="outeline" title="Ta bort område" size="sm" @click="remove($event,l)">
                    <i class="fa-solid fa-circle-xmark"></i>
                </b-button>
            </b-button>
            <hr>
            <b-button v-if="cmd=='savearea'" @click="saveArea">Spara</b-button>
            <b-button v-if="cmd=='loadarea'" @click="loadArea">Hämta</b-button>
        </b-card-body>
    </b-card>
</template>
<script>
import { Api } from "../../lib/api";
const api = new Api();

export default {
    name: 'geoarea',
    props: { cmd:String, data:Object },
    created() {
        this.getList();
    },
    data() {
        return {
            list:[],
            name:null,            
        }
    },
    methods: {
        getList() {
            api.get('/api/geo/GetAreas').then(res => {
                this.list = res.data;
            })
        },
        saveArea() {
            if(!this.name) {
                alert('Du måste ange namn på området.');
                return;
            }
            var p = {id:0,name:this.name,areaJson:JSON.stringify(this.data)};
            api.post('/api/geo/SaveArea',p).then(res => {
                //alert(res.data);
                this.getList();
            });
        },
        loadArea() {
            if(!this.name) {
                alert('Du måste ange namn på området.');
                return;
            }        
            api.get('/api/geo/LoadArea?name='+this.name).then(res => {
                if(!res.data) {
                    alert('Kunde inte hämta området.');
                    return;
                }
                    
                var ctx = {cmd:'loadarea',data:res.data};
                this.$emit('cmd',ctx);
            });

        },
        remove(ev,l) {
            if(ev)
                ev.stopPropagation();

            if(confirm(`Vill du ta bort ${l}?`)) {
                api.delete('/api/geo/DeleteArea?name='+l).then(res => {
                    if(res.data)
                        alert(res.data);
                    this.getList();
                })
            }
        }
    }
}

</script>